import { useState, useEffect } from "react";
import { Loader2, UserCheck, Save } from "lucide-react";
import { colors, fonts } from "../../styles/theme";
import { Button } from "../../components/ui";
import {
  fetchSystemSettings,
  updateSystemSettings,
} from "../../services/api";
import { inputStyle } from "./constants";

export default function SalesEmailSection() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSystemSettings()
      .then((s) => setEmail(s?.salesEmail || ""))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("Please enter a valid email address");
      return;
    }
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      await updateSystemSettings({ salesEmail: trimmed });
      setSuccess("Sales email updated");
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        background: colors.bgCard,
        border: `1px solid ${colors.border}`,
        borderRadius: 8,
        padding: 24,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: 16,
        }}
      >
        <UserCheck size={18} color={colors.accent} />
        <h3
          style={{
            fontFamily: fonts.heading,
            fontSize: 16,
            color: colors.text,
            margin: 0,
          }}
        >
          Sales Follow-up Email
        </h3>
      </div>

      <p
        style={{
          fontSize: 12,
          color: colors.textSecondary,
          marginBottom: 16,
          lineHeight: 1.5,
        }}
      >
        The email address that receives Chairman&apos;s Access enquiry
        notifications for sales follow-up.
      </p>

      {error && (
        <div
          style={{
            padding: "8px 12px",
            marginBottom: 12,
            borderRadius: 6,
            background: "rgba(239,68,68,0.1)",
            color: colors.danger,
            fontSize: 12,
          }}
        >
          {error}
        </div>
      )}
      {success && (
        <div
          style={{
            padding: "8px 12px",
            marginBottom: 12,
            borderRadius: 6,
            background: "rgba(16,185,129,0.1)",
            color: colors.success,
            fontSize: 12,
          }}
        >
          {success}
        </div>
      )}

      {loading ? (
        <Loader2
          size={16}
          color={colors.textSecondary}
          className="spin"
        />
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setSuccess(null);
              setError(null);
            }}
            placeholder="e.g. user@example.com"
            style={{ ...inputStyle, maxWidth: 320 }}
          />
          <Button
            variant="primary"
            size="sm"
            icon={Save}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </Button>
        </div>
      )}
    </div>
  );
}
